import React from 'react';

type Width = 'wide' | 'narrow' | 'tight';

export type PageProps = React.HTMLAttributes<HTMLDivElement> & {
  width?: Width;
};

const widthClass: Record<Width, string> = {
  wide: 'page',
  narrow: 'page-narrow',
  tight: 'page-tight',
};

export const Page: React.FC<PageProps> = ({ width = 'wide', className = '', ...rest }) => (
  <div className={`${widthClass[width]} ${className}`} {...rest} />
);

export const PageHead: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  ...rest
}) => <div className={`page-head ${className}`} {...rest} />;

export const PageTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
  className = '',
  children,
  ...rest
  // eslint-disable-next-line jsx-a11y/heading-has-content
}) => <h1 className={`page-title ${className}`} {...rest}>{children}</h1>;

export const PageSub: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = ({
  className = '',
  ...rest
}) => <p className={`page-sub ${className}`} {...rest} />;
